export const category = "category";
export const name = "name";
export const articleId = "articleId";
export const sku = "sku";
export const variantCode = "variantCode";
export const size = "size";
export const price = "price";
export const packageSize = "packageSize";
export const month0 = "month0";
export const month1 = "month1";
export const month2 = "month2";
export const stockOrder = "stockOrder";
export const articleName = "articleName";
export const ean = "ean";
export const estimatedQty = "estimatedQty";
export const ordered = "ordered";
export const liabilityMet = "liabilityMet";
export const month = "month";
export const availableStock = "availableStock";
export const season = "season";
export const eanPack = "eanPack";
export const isCollab = "isCollab";
export const collectionSegment = "collectionSegment";
export const assortmentSegment = "assortmentSegment";

export type EstimationColumn =
  | "category"
  | "season"
  | "name"
  | "articleId"
  | "sku"
  | "variantCode"
  | "ean"
  | "eanPack"
  | "isCollab"
  | "collectionSegment"
  | "assortmentSegment"
  | "size"
  | "price"
  | "packageSize"
  | "month0"
  | "month1"
  | "month2";

export type OrderColumn =
  | "category"
  | "season"
  | "name"
  | "articleId"
  | "sku"
  | "variantCode"
  | "ean"
  | "eanPack"
  | "isCollab"
  | "collectionSegment"
  | "assortmentSegment"
  | "size"
  | "price"
  | "packageSize"
  | "ean"
  | "estimatedQty"
  | "ordered"
  | "liabilityMet"
  | "month"
  | "availableStock"
  | "stockOrder";

const estimationExcelColumn: EstimationColumn[] = [
  category,
  season,
  name,
  articleId,
  sku,
  variantCode,
  ean,
  eanPack,
  isCollab,
  collectionSegment,
  assortmentSegment,
  size,
  price,
  packageSize,
  month0,
  month1,
  month2,
];

export const orderExcelColumn: OrderColumn[] = [
  category,
  season,
  name,
  articleId,
  sku,
  variantCode,
  ean,
  eanPack,
  isCollab,
  collectionSegment,
  assortmentSegment,
  size,
  price,
  packageSize,
  estimatedQty,
  ordered,
  liabilityMet,
  month,
  availableStock,
  stockOrder,
];

export const estimationColumnsNeededForImport: EstimationColumn[] = [
  articleId,
  sku,
  month0,
  month1,
  month2,
];

export const orderColumnsNeededForImport: OrderColumn[] = [
  articleId,
  sku,
  month,
  stockOrder,
];

export default estimationExcelColumn;

export const getIndex = <T>(columns: T[], allColumns: T[]): number[] =>
  columns.map((c: T) => allColumns.indexOf(c));



// WEBPACK FOOTER //
// ./src/view/common/excelColumns.ts